import { useEffect } from 'react';
import { useIsSessionExpired } from './useUser';

const useRefreshWarning = (condition: boolean) => {
    const isSessionExpired = useIsSessionExpired();

    useEffect(() => {
        if (!isSessionExpired) {
            const handlePageRefresh = (e: BeforeUnloadEvent) => {
                if (condition) {
                    e.preventDefault();
                    e.returnValue = true;
                    return true; // Gecko + Webkit, Safari, Chrome etc.
                }
            };

            const handlePopState = (e: PopStateEvent) => {
                if (condition) {
                    const confirmationMessage =
                        'You have unsaved changes. Are you sure you want to leave?';
                    e.preventDefault();
                    if (window.confirm(confirmationMessage)) {
                        window.history.go();
                    } else {
                        window.history.pushState(null, '', window.location.href);
                    }
                }
            };

            window.addEventListener('beforeunload', handlePageRefresh);
            window.addEventListener('popstate', handlePopState);

            return () => {
                window.removeEventListener('beforeunload', handlePageRefresh);
                window.removeEventListener('popstate', handlePopState);
            };
        }
    }, [condition, isSessionExpired]);
};

export { useRefreshWarning };
